module.exports = __webpack_public_path__ + "media/reskin-images/icon--resources-b88c06e1.svg";